import { extractGuid, extractMeta } from "../utilities/dropFieldContainerHelper";
import type { DraggableFieldType, DraggableMetaType, FieldWrapper } from "../../../../../../../../api/types/svTypes.ts";

export const getKeyValue = (field: FieldWrapper<DraggableFieldType> | DraggableMetaType) => {
  const guid = extractGuid(field);
  if (guid) {
    return guid;
  }
  const meta = extractMeta(field);
  if (meta) {
    return meta.name;
  }
  return "";
};
